/*
 * @Description:
 * @Author: DRER6
 * @Date: 2020-08-17 15:13:24
 * @LastEditTime: 2020-11-01 15:19:30
 * @LastEditors: qianjun
 */

import {
    axiosNewAjax,
    axiosAjax
} from '@/utils/ajax'

export default class scoreAnalysisApi {
    /**
     * @name: 培训班统计分析
     */
    static getTrainClassStudyInfoByParams(data) {
        return axiosNewAjax('post', '/studyapp-service/trainClass/getTrainClassStudyInfoByParams', data)
    }

    //培训班统计分析详情
    static getTrainClassUseState(data) {
        return axiosNewAjax('get', '/studyapp-service/trainClass/getTrainClassUseState', data)
    }

    //培训班学习请情况
    static getTrainClassStudentCountNew(data) {
        return axiosNewAjax('post', '/studyapp-service/trainClass/getTrainClassStudentCountNew', data)
    }

    //培训班统计分析图标
    static getTrainClassStudyCount(data) {
        return axiosAjax('get', '/studyapp-service/trainClass/getTrainClassStudyCount', data)
    }
}



// WEBPACK FOOTER //
// ./src/api/scoreAnalysisApi.js